import {ui} from "./ui";
import {flags} from "./flags";
import {combineReducers} from "redux";

export default combineReducers({
    ui,
    flags
})
